export interface PlayableAudio {
  currentTime: number;
  play(): Promise<unknown>;
}

export async function playAudioSafely(audio: PlayableAudio): Promise<void> {
  try {
    audio.currentTime = 0;
    await audio.play();
  } catch {
    // Autoplay policies may reject playback before a trusted user gesture.
  }
}
